import { z } from 'zod/v3';
import { isDayjs } from 'dayjs';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { ISO_DATE_FORMAT, zIsoDate } from '../../common/utils';

const { t } = i18nNsFactory('validation-rule-test-run-modal');

export const ValidateRequiredKeysFormSchema = z.object({
  valueDate: z.preprocess(
    (v) => {
      if (v == null || v === '') return undefined;
      if (isDayjs(v)) return v.format(ISO_DATE_FORMAT);
      if (typeof v === 'string') return v;
      return v;
    },
    zIsoDate(() => t('validation.valueDate.required')),
  ),
});
